import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import AppsIcon from '@mui/icons-material/Apps';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CarRentalIcon from '@mui/icons-material/CarRental';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import Divider from '@mui/material/Divider';
import {
  Button,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MuiAlert from '@mui/material/Alert';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import Menu from '@mui/material/Menu';
import AlertTitle from '@mui/material/AlertTitle';
import LogoutIcon from '@mui/icons-material/Logout';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import IconButton from '@mui/material/IconButton';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AdfScannerOutlinedIcon from '@mui/icons-material/AdfScannerOutlined';
import AspectRatioOutlinedIcon from '@mui/icons-material/AspectRatioOutlined';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import Header from './Header'
import { doLogout } from '../../pages/Auth/authSlice';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Sidebar = ({ currentPage, connectQZ, disconnectQZ }) => {
  const params = new URLSearchParams(window.location.search)
  let urlParam = params.get('report')
  const logout = () => {
    window.location.reload();
    dispatch(doLogout());
  }
  const profile = useSelector(state => state.auth);
  const qzState = useSelector(state => state.qz);
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuopen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDrawerClick = () => {
    setOpen(!open);
  };

  const dispatch = useDispatch();
  const drawerWidth = 260;

  const openedMixin = (theme) => ({
    width: drawerWidth,
    borderRight: '1px solid #E2E8F0',
    backgroundColor: '#FFFFFF',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden'
  });

  const closedMixin = (theme) => ({
    borderRight: '1px solid #E2E8F0',
    backgroundColor: '#FFFFFF',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(8)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(9)} + 1px)`,
    },
  });

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
    ...theme.mixins.toolbar,
  }));

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: 'none',
    borderBottom: '1px solid #E2E8F0',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      }),
      ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      }),
    }),
  );
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };
  const showdrawerhandle = () => {
    setShowDrawer(showDrawer ? false : true)
  }

  // Common shared styles for modern workspace link row actions
  const enterpriseItemStyles = (isActive) => ({
    borderRadius: '10px',
    mx: open ? 1.5 : 'auto', // Centers the icon square when the navbar shrinks
    my: 0.25,
    width: open ? 'calc(100% - 24px)' : '48px', // Reduces horizontal footprint when closed
    height: '48px',
    justifyContent: open ? 'initial' : 'center',
    transition: 'all 0.15s ease-in-out',
    backgroundColor: isActive ? '#F0F9FF' : 'transparent',
    color: isActive ? '#0369A1' : '#475569',
    '& .MuiListItemIcon-root': {
      color: isActive ? '#0369A1' : '#64748B',
      minWidth: open ? '40px' : '0px',
      justifyContent: 'center'
    },
    '& .MuiTypography-root': {
      fontWeight: isActive ? 700 : 600,
      fontSize: '13.5px'
    },
    '&:hover': {
      backgroundColor: isActive ? '#E0F2FE' : '#F8FAFC',
      color: isActive ? '#0369A1' : '#0F172A',
      '& .MuiListItemIcon-root': {
        color: isActive ? '#0369A1' : '#0F172A'
      }
    }
  });

  return (
    <>
      <Menu
        id="basic-menu"
        className="logout--menu"
        anchorEl={anchorEl}
        open={menuopen}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 220,
            borderRadius: '12px',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04)',
            border: '1px solid #E2E8F0',
            p: 0.5
          }
        }}
      >
        <Box sx={{ p: 0.5 }}>
          <Typography variant="caption" sx={{ px: 2, py: 1, display: 'block', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', fontSize: '11px' }}>
            Integrations
          </Typography>

          {/* ─── CONDITIONALLY RENDER MARKETPLACE ONLY ─── */}
          {(profile && profile.profile && (profile.profile.id == profile.profile.parent_id)) && (
            <ListItemButton 
              component={Link} 
              to="/integration/marketplace" 
              onClick={handleClose}
              sx={enterpriseItemStyles(currentPage === "integration/marketplace" && urlParam !== "scheduledemo")}
            >
              <ListItemIcon><StorefrontIcon sx={{ fontSize: '18px' }} /></ListItemIcon>
              <ListItemText primary="Marketplace" />
            </ListItemButton>
          )}

          <ListItemButton 
            component={Link} 
            to="/integration/notification" 
            onClick={handleClose}
            sx={enterpriseItemStyles(currentPage === "integration/notification")}
          >
            <ListItemIcon><NotificationsNoneOutlinedIcon sx={{ fontSize: '18px' }} /></ListItemIcon>
            <ListItemText primary="Notification" />
          </ListItemButton>
          <Divider sx={{ my: 1, borderColor: '#F1F5F9' }} />
        </Box>
        
        <Box sx={{ p: 0.5 }}>
          <Typography variant="caption" sx={{ px: 2, py: 1, display: 'block', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', fontSize: '11px' }}>
            Account Settings
          </Typography>
          {(profile && profile.profile && profile.profile.hide_rate === false || typeof profile.profile.hide_rate=="undefined") && (
            <ListItemButton component={Link} to="/settings/invoices" onClick={handleClose} sx={enterpriseItemStyles(currentPage === "settings/invoices")}>
              <ListItemIcon><ReceiptIcon sx={{ fontSize: '18px' }} /></ListItemIcon>
              <ListItemText primary="Invoices" />
            </ListItemButton>
          )}
          <ListItemButton component={Link} to="/settings/profile" onClick={handleClose} sx={enterpriseItemStyles(currentPage === "settings/profile")}>
            <ListItemIcon><SettingsOutlinedIcon sx={{ fontSize: '18px' }} /></ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItemButton>
          <Divider sx={{ my: 1, borderColor: '#F1F5F9' }} />
          <ListItemButton onClick={logout} sx={{ ...enterpriseItemStyles(false), color: '#EF4444', '& .MuiListItemIcon-root': { color: '#EF4444' }, '&:hover': { backgroundColor: '#FEF2F2', color: '#DC2626', '& .MuiListItemIcon-root': { color: '#DC2626' } } }}>
            <ListItemIcon><LogoutIcon sx={{ fontSize: '18px' }} /></ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </Box>
      </Menu>

      <CssBaseline />
      
      <AppBar 
        position="fixed" 
        open={open} 
        style={{
          backgroundColor: profile.profile.status && profile.profile.status === "ACTIVE" 
            ? profile.profile.user_dashboard_message_background_color_code
            : "#FFFFFF" 
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', height: 64, px: '24px !important' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerClick}
            edge="start"
            sx={{
              color: '#475569',
              border: '1px solid #E2E8F0',
              borderRadius: '10px',
              p: 0.75,
              mr: 2,
              transition: 'all 0.2s',
              '&:hover': { backgroundColor: '#F8FAFC', color: '#0F172A' },
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon sx={{ fontSize: '20px' }} />
          </IconButton>
          
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
            <Header />
          </Box>
          
          <Box 
            aria-controls={menuopen ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={menuopen ? 'true' : undefined}
            onClick={handleClick}
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1.5, 
              cursor: 'pointer',
              p: 0.75,
              borderRadius: '12px',
              transition: 'all 0.15s ease-in-out',
              backgroundColor: '#FFFFFF', 
              borderColor: '#E2E8F0',     
              borderStyle: 'solid',
              borderWidth: '1px',
              '&:hover': { 
                backgroundColor: '#F8FAFC' 
              }
            }}
          >
            <Avatar sx={{ width: 32, height: 32, bgcolor: '#0284C7', fontSize: '14px', fontWeight: 700, color: '#FFFFFF' }} className='sc--header--avatar'>
              {profile.profile.name.charAt(0).toUpperCase()}
            </Avatar>
            <Typography variant="body2" sx={{ fontWeight: 700, color: '#1E293B', fontSize: '13.5px', display: open ? 'block' : 'none' }}>
              {profile.profile.name}
            </Typography>
            <KeyboardArrowDownIcon 
              sx={{ 
                color: '#64748B', 
                fontSize: '18px', 
                display: open ? 'block' : 'none',
                transition: 'transform 0.15s ease-in-out',
                ...(menuopen && { transform: 'rotate(180deg)' }) // Rotates smoothly if dropdown menu is active
              }} 
            />
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ height: 64, borderBottom: '1px solid #E2E8F0', px: 2 }}>
          <Box component="a" href="/" sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }} className="logo-link">
            <Box 
              component="img" 
              className="loginlogo" 
              src="/assets/images/shippingchimp_logo.png" 
              alt="logo-dark" 
              sx={{ 
                width: 170,
                objectFit: 'contain',
                transition: 'opacity 0.15s',
                opacity: open ? 1 : 0
              }} 
            />
          </Box>
          <IconButton 
            onClick={handleDrawerClick}
            sx={{
              color: '#64748B',
              border: '1px solid #E2E8F0',
              borderRadius: '8px',
              p: 0.5,
              '&:hover': { backgroundColor: '#F8FAFC', color: '#0F172A' }
            }}
          >
            {open ? <ChevronLeftIcon sx={{ fontSize: '18px' }} /> : <ChevronRightIcon sx={{ fontSize: '18px' }} />}
          </IconButton>
        </DrawerHeader>
        
        <Box sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden', py: 2 }}>
          <List sx={{ p: 0 }}>
            {/* Core Overview Anchor Link Row */}
            <ListItemButton component={Link} to="/dashboard" selected={currentPage === "dashboard"} onClick={(event) => handleListItemClick(event, 0)} sx={enterpriseItemStyles(currentPage === "dashboard")}>
              <ListItemIcon><AppsIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Dashboard" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <Typography variant="caption" sx={{ px: 3, py: 1.5, display: open ? 'block' : 'none', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
              Fulfillment Cluster
            </Typography>

            {/* Comprehensive Order Registers Sub-Tree Link mapping arrays */}
            <ListItemButton component={Link} to="/orders-new/all" selected={currentPage === "orders-new/all" && urlParam == null} onClick={(event) => handleListItemClick(event, 2)} sx={enterpriseItemStyles(currentPage === "orders-new/all" && urlParam == null)}>
              <ListItemIcon><ArticleOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="All Orders" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <ListItemButton component={Link} to="/orders-new/all?report=openorders" selected={urlParam === "openorders"} onClick={(event) => handleListItemClick(event, 2)} sx={enterpriseItemStyles(urlParam === "openorders")}>
              <ListItemIcon><FolderOpenOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Open Orders" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <ListItemButton component={Link} to="/orders-new/all?report=returnorders" selected={urlParam === "returnorders"} onClick={(event) => handleListItemClick(event, 2)} sx={enterpriseItemStyles(urlParam === "returnorders")}>
              <ListItemIcon><KeyboardReturnOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Return Orders" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <ListItemButton component={Link} to="/orders/bulk" selected={currentPage === "orders/bulk"} onClick={(event) => handleListItemClick(event, 4)} sx={enterpriseItemStyles(currentPage === "orders/bulk")}>
              <ListItemIcon><AddBusinessOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Bulk Order" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <ListItemButton component={Link} to="/orders/picklist" selected={currentPage === "orders/picklist"} onClick={(event) => handleListItemClick(event, 4)} sx={enterpriseItemStyles(currentPage === "orders/picklist")}>
              <ListItemIcon><FactCheckOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Order Picklist" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <ListItemButton component={Link} to="/reports/manifests" selected={currentPage === "reports/manifests"} onClick={(event) => handleListItemClick(event, 6)} sx={enterpriseItemStyles(currentPage === "reports/manifests")}>
              <ListItemIcon><AssignmentTurnedInOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Manifests" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

           {profile && profile.profile && profile.profile.enable_pickup_menu === 1 && (
              <ListItemButton component={Link} to="/reports/pickup" selected={currentPage === "reports/pickup"} onClick={(event) => handleListItemClick(event, 7)} sx={enterpriseItemStyles(currentPage === "reports/pickup")}>
                <ListItemIcon><LocalMallOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
                <ListItemText primary="Pickup" sx={{ display: open ? 'block' : 'none' }} />
              </ListItemButton>
            )}

            <Typography variant="caption" sx={{ px: 3, py: 1.5, display: open ? 'block' : 'none', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.5px' }}>
              Data & Auditing Logs
            </Typography>

            <ListItemButton component={Link} to="/reports/deliveries" selected={currentPage === "reports/deliveries"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "reports/deliveries")}>
              <ListItemIcon><LocalShippingOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Deliveries" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>
            {profile && profile.profile && profile.profile.reports && profile.profile.reports.fulfillment_report===true && (
            <ListItemButton component={Link} to="/reports/fulfillments" selected={currentPage === "reports/fulfillments"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "fullfillments")}>
              <ListItemIcon><AnalyticsOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Fullfillments" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>
            )}
            <ListItemButton component={Link} to="/reports/dim-update" selected={currentPage === "reports/dim-update"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "reports/dim-update")}>
              <ListItemIcon><AspectRatioOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Dim Update" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            <ListItemButton component={Link} to="/reports/departure" selected={currentPage === "reports/departure"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "reports/departure")}>
              <ListItemIcon><AdfScannerOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Departure Scan" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>
            
            {/* <ListItemButton component={Link} to="/reports/return-departure" selected={currentPage === "reports/return-departure"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "reports/return-departure")}>
              <ListItemIcon><AssignmentReturnOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Return Departure Scan" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton> */}

            <ListItemButton component={Link} to="/claims" selected={currentPage === "claims"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "claims")}>
              <ListItemIcon><NewspaperIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Claims" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            {profile && profile.profile && profile.profile.is_analytics_report_enabled === true && (
              <ListItemButton component={Link} to="/analytics" selected={currentPage === "analytics"} onClick={(event) => handleListItemClick(event, 5)} sx={enterpriseItemStyles(currentPage === "analytics")}>
                <ListItemIcon><AssessmentOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
                <ListItemText primary="Analytics" sx={{ display: open ? 'block' : 'none' }} />
              </ListItemButton>
            )}

            <ListItemButton component={Link} to="/inventory" selected={currentPage.includes("inventory")} sx={enterpriseItemStyles(currentPage.includes("inventory"))}>
              <ListItemIcon><ReceiptOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
              <ListItemText primary="Inventory" sx={{ display: open ? 'block' : 'none' }} />
            </ListItemButton>

            {profile && profile.profile && (profile.profile.id == profile.profile.parent_id) && (
              <ListItemButton component={Link} to={{ pathname: "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1zZ8qhs6dpVoGQ53GUA-TU39VuoVvdypM5AeiiibgPmgd4CzgnBgM972phfZso-7OgiNr57mnZ?pli=1?name="+profile.profile.name+"&email="+profile.profile.email }} target="_blank" selected={urlParam === "scheduledemo"} onClick={(event) => handleListItemClick(event, 8)} sx={enterpriseItemStyles(urlParam === "scheduledemo")}>
                <ListItemIcon><CalendarMonthOutlinedIcon sx={{ fontSize: '20px' }} /></ListItemIcon>
                <ListItemText primary="Schedule Demo" sx={{ display: open ? 'block' : 'none' }} />
              </ListItemButton>
            )}
          </List>
        </Box>
      </Drawer>
    </>
  )
}

export default Sidebar;